import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Iterable } from 'immutable';

import { ToastMessageContainer } from '../ToastMessage';
import { PoorNetToastMessageContainer } from '../PoorNetToastMessage';

import './ToastMessagesList.custom.scss';

function ListMessages(props) {
  const {
    messages,
    verticalPosition,
    horizontalPosition,
  } = props;

  return (
    <section className={classnames(
        `toast-messages-list-${verticalPosition}`,
        `toast-messages-list-${horizontalPosition}`,
        'toast-messages-list'
      )
    }>
      {mapMessages(messages)}
    </section>
  );
}

function mapMessages (messages) {
  return messages
    .map(data => {
      const { id, poorNetworkConnection } = data;
      const Component = poorNetworkConnection ?
        PoorNetToastMessageContainer :
        ToastMessageContainer;

      return (
        <Component
          key={id}
          {...data}
        />
      );
    })
}

export default function ToastMessagesList (props) {
  const {
    messagesRightTop,
  } = props;

  return (
    <section className='react-root-toast-messages'>
      <ListMessages
        verticalPosition={'right'}
        horizontalPosition={'top'}
        messages={messagesRightTop}
      />
    </section>
  );
}

ToastMessagesList.propTypes = {
  messagesRightTop: PropTypes.oneOfType([
    PropTypes.instanceOf(Iterable),
    PropTypes.array,
  ]).isRequired,
};
